/**
 * @generated SignedSource<<c578f4b6ed0a6d21b1e75df7a7314ea6>>
 * @relayHash 001479667d813d2a68488691c558957a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d209e1609f5c010b3de45f16492e24d50d16695ae75e4bbab80c6f9de058f8fc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TemplateResultsQuery$variables = {
  cloudId: string;
  first: number;
  product?: string | null;
};
export type TemplateResultsQuery$data = {
  readonly agentStudio_getAllTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly previewRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateView_StudioBrowseKit">;
        };
        readonly templateRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateCard_StudioBrowseKit">;
        };
      } | null;
    } | null> | null;
  } | null;
};
export type TemplateResultsQuery = {
  response: TemplateResultsQuery$data;
  variables: TemplateResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "product"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TemplateResultsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateCard_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "templateRef"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateView_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "previewRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateResultsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "avatarUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "usageCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "templateAppKeys"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "tags"
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateSupportedTrigger",
                    "kind": "LinkedField",
                    "name": "supportedTriggers",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateHowItWorksStep",
                    "kind": "LinkedField",
                    "name": "howItWorks",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "role"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "text"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d209e1609f5c010b3de45f16492e24d50d16695ae75e4bbab80c6f9de058f8fc",
    "metadata": {},
    "name": "TemplateResultsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b6c8372627cbda48bd978b22effbf153";

export default node;
